'use strict';

var CssJs = require("bs-css-emotion/lib/js/src/CssJs.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Css_Js_Core = require("bs-css/lib/js/src/Css_Js_Core.js");
var RescriptReactRouter = require("@rescript/react/lib/js/src/RescriptReactRouter.js");
var Link$PvpcontrollerWeb = require("./Link.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var ArmorIcon$PvpcontrollerWeb = require("./icons/ArmorIcon.js");
var ArrowIcon$PvpcontrollerWeb = require("./icons/ArrowIcon.js");
var SwordIcon$PvpcontrollerWeb = require("./icons/SwordIcon.js");
var MobileDetect$PvpcontrollerWeb = require("../MobileDetect.js");
var EditModePrompt$PvpcontrollerWeb = require("./EditModePrompt.js");

var nav = CssJs.style([CssJs.backgroundColor(Theme$PvpcontrollerWeb.navBarColor)]);

var navLinkColor = CssJs.hex("abb6c7");

var navLinkHighlightedColor = CssJs.hex("007fd8");

var navInside = CssJs.style([
      CssJs.display("flex"),
      CssJs.justifyContent(CssJs.spaceBetween),
      CssJs.padding4(CssJs.zero, CssJs.px(15), CssJs.zero, CssJs.px(15)),
      CssJs.maxWidth(CssJs.px(1300)),
      CssJs.margin(CssJs.auto),
      CssJs.height(CssJs.px(75))
    ]);

var title = CssJs.style([
      CssJs.fontFamily({
            NAME: "custom",
            VAL: "Lilita One"
          }),
      CssJs.unsafe("background", "-webkit-radial-gradient(0% 60%, #0095ff, #0070bf)"),
      CssJs.unsafe("WebkitTextFillColor", "transparent"),
      CssJs.unsafe("WebkitBackgroundClip", "text"),
      CssJs.fontSize(CssJs.px(40)),
      CssJs.margin2(CssJs.auto, CssJs.px(0)),
      CssJs.fontWeight({
            NAME: "num",
            VAL: 400
          })
    ]);

var titleGroup = CssJs.style([
      CssJs.display("flex"),
      CssJs.alignItems(CssJs.center)
    ]);

var editIcon = CssJs.style([
      CssJs.color(CssJs.hex("739ee2")),
      CssJs.fontSize(CssJs.px(20)),
      CssJs.marginLeft(CssJs.px(20)),
      CssJs.marginTop(CssJs.px(5))
    ]);

var navList = CssJs.style([CssJs.display("flex")]);

function navItem(highlighted) {
  return CssJs.style([
              highlighted ? CssJs.color(navLinkHighlightedColor) : CssJs.color(navLinkColor),
              CssJs.fontSize(CssJs.px(20)),
              CssJs.width(CssJs.px(120)),
              CssJs.textAlign(CssJs.center),
              CssJs.textDecoration(CssJs.none),
              CssJs.display("flex"),
              CssJs.alignItems(CssJs.center),
              CssJs.hover([CssJs.backgroundColor(CssJs.hex("202225"))])
            ]);
}

var navItemInner = CssJs.style([CssJs.margin(CssJs.auto)]);

var navMenu = CssJs.style([
      CssJs.fontSize(CssJs.px(20)),
      CssJs.margin(CssJs.auto),
      CssJs.color(CssJs.hex("abb6c7")),
      CssJs.cursor(CssJs.pointer),
      CssJs.width(CssJs.rem(1)),
      CssJs.padding2(CssJs.zero, CssJs.rem(1)),
      CssJs.margin4(CssJs.px(-10), CssJs.px(-15), CssJs.px(-20), CssJs.px(-15)),
      CssJs.padding4(CssJs.px(20), CssJs.px(15), CssJs.px(20), CssJs.px(25)),
      CssJs.unsafe("WebkitTapHighlightColor", "transparent")
    ]);

var smallScreenMenu = CssJs.style([
      CssJs.position(CssJs.fixed),
      CssJs.left(CssJs.zero),
      CssJs.top(CssJs.zero),
      CssJs.height({
            NAME: "percent",
            VAL: 100
          }),
      CssJs.display("flex"),
      CssJs.zIndex(9999),
      CssJs.padding2(CssJs.rem(0.2), CssJs.rem(0.2)),
      CssJs.width({
            NAME: "percent",
            VAL: 100
          })
    ]);

var iconHeight = CssJs.rem(1.1);

var iconWidth = CssJs.rem(1.3);

var navItemLabel = CssJs.style([CssJs.marginLeft(CssJs.rem(2.0))]);

function navItemIcon(highlighted) {
  return CssJs.style([
              CssJs.display(CssJs.block),
              CssJs.margin2(CssJs.auto, CssJs.zero),
              Css_Js_Core.SVG.fill(highlighted ? navLinkHighlightedColor : navLinkColor),
              CssJs.width(iconWidth),
              CssJs.height(iconHeight),
              CssJs.child("div", [CssJs.child("svg", [
                          CssJs.width(iconWidth),
                          CssJs.height(iconHeight),
                          CssJs.position(CssJs.relative),
                          CssJs.bottom(CssJs.rem(0.1))
                        ])])
            ]);
}

function smallNavItem(highlighted) {
  return CssJs.style([
              highlighted ? CssJs.color(navLinkHighlightedColor) : CssJs.color(navLinkColor),
              CssJs.fontSize(CssJs.px(20)),
              CssJs.textAlign("left"),
              CssJs.paddingLeft(CssJs.rem(1)),
              CssJs.paddingTop(CssJs.rem(1.0)),
              CssJs.paddingBottom(CssJs.rem(1.0)),
              CssJs.textDecoration(CssJs.none),
              CssJs.display("flex"),
              CssJs.alignItems(CssJs.center),
              CssJs.child("i", [
                    CssJs.width(iconWidth),
                    CssJs.height(iconHeight)
                  ])
            ]);
}

var smallTitle = CssJs.style([CssJs.margin4(CssJs.rem(1.0), CssJs.auto, CssJs.zero, CssJs.auto)]);

var menuContent = CssJs.style([
      CssJs.display("flex"),
      CssJs.flexDirection(CssJs.column),
      CssJs.background(CssJs.hex("181a1d")),
      CssJs.width({
            NAME: "percent",
            VAL: 75
          })
    ]);

var shade = CssJs.style([
      CssJs.background(CssJs.rgba(0, 0, 0, {
                NAME: "percent",
                VAL: 50
              })),
      CssJs.flexGrow(1)
    ]);

var smallMenuHr = CssJs.style([
      CssJs.width({
            NAME: "percent",
            VAL: 90.0
          }),
      CssJs.margin2(CssJs.em(0.8), CssJs.auto),
      CssJs.borderColor({
            NAME: "hex",
            VAL: "0095ff"
          })
    ]);

var navLinks = [
  {
    key: "dashboard",
    name: "Dashboard",
    href: "/dashboard",
    icon: {
      TAG: /* Class */0,
      _0: "fas fa-home"
    },
    isLandingPage: true
  },
  {
    key: "weapons",
    name: "Weapons",
    href: "/weapons",
    icon: {
      TAG: /* Component */1,
      _0: React.createElement(SwordIcon$PvpcontrollerWeb.make, {})
    },
    isLandingPage: false
  },
  {
    key: "projectiles",
    name: "Projectiles",
    href: "/projectiles",
    icon: {
      TAG: /* Component */1,
      _0: React.createElement(ArrowIcon$PvpcontrollerWeb.make, {})
    },
    isLandingPage: false
  },
  {
    key: "armor",
    name: "Armor",
    href: "/armor",
    icon: {
      TAG: /* Component */1,
      _0: React.createElement(ArmorIcon$PvpcontrollerWeb.make, {})
    },
    isLandingPage: false
  },
  {
    key: "settings",
    name: "Settings",
    href: "/settings",
    icon: {
      TAG: /* Class */0,
      _0: "fas fa-cog"
    },
    isLandingPage: false
  }
];

function Nav$Mobile(Props) {
  var session = Props.session;
  var editMode = Props.editMode;
  var setEditMode = Props.setEditMode;
  var match = React.useState(function () {
        return false;
      });
  var setShowingEditPrompt = match[1];
  var page = Belt_List.head(RescriptReactRouter.useUrl(undefined, undefined).path);
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowingMenuDropDown = match$1[1];
  var showingMenuDropDown = match$1[0];
  var tmp;
  if (typeof session === "object" && session.NAME === "Verified") {
    switch (editMode) {
      case /* Unknown */0 :
          tmp = React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps({
                    height: "13px",
                    margin: "0",
                    marginTop: "5px",
                    marginLeft: "20px",
                    minWidth: "13px",
                    width: "13px"
                  }, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
          break;
      case /* Enabled */1 :
          tmp = React.createElement(React.Fragment, undefined);
          break;
      case /* Disabled */2 :
          tmp = React.createElement("i", {
                key: "editModeEnable",
                className: editIcon + " fas fa-edit",
                onClick: (function (param) {
                    return Curry._1(setShowingEditPrompt, (function (_previousState) {
                                  return true;
                                }));
                  })
              });
          break;
      
    }
  } else {
    tmp = React.createElement(React.Fragment, undefined);
  }
  var tmp$1;
  if (showingMenuDropDown) {
    var tmp$2;
    if (typeof session === "object") {
      tmp$2 = React.createElement(React.Fragment, undefined);
    } else {
      var currentUrl = window.location.href;
      tmp$2 = React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("https://login.dark-gaming.com/?redirect=" + currentUrl, smallNavItem(Caml_obj.caml_equal(page, "login")), null, false, undefined, "login", undefined), React.createElement("i", {
                className: "fas fa-sign-in-alt"
              }), React.createElement("div", {
                className: navItemLabel
              }, "Login"));
    }
    tmp$1 = React.createElement("div", {
          className: smallScreenMenu
        }, React.createElement("div", {
              className: menuContent
            }, React.createElement("h1", {
                  key: "h1",
                  className: CssJs.merge([
                        title,
                        smallTitle
                      ])
                }, "PvP Manager"), React.createElement("hr", {
                  className: smallMenuHr
                }), navLinks.map(function (param) {
                  var icon = param.icon;
                  var key = param.key;
                  var isCurrentLandingPage = Belt_Option.mapWithDefault(page, "", (function (page) {
                          return page;
                        })).length === 0 && param.isLandingPage;
                  var isCurrentPage = Caml_obj.caml_equal(page, key);
                  var tmp;
                  tmp = icon.TAG === /* Class */0 ? React.createElement("i", {
                          className: icon._0
                        }) : React.createElement("div", {
                          className: navItemIcon(Caml_obj.caml_equal(page, key))
                        }, icon._0);
                  return React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps(param.href, smallNavItem(isCurrentPage || isCurrentLandingPage), null, undefined, (function (param) {
                                    return Curry._1(setShowingMenuDropDown, (function (param) {
                                                  return false;
                                                }));
                                  }), key, undefined), tmp, React.createElement("div", {
                                  className: navItemLabel
                                }, param.name));
                }), tmp$2), React.createElement("div", {
              className: shade,
              onClick: (function (param) {
                  return Curry._1(setShowingMenuDropDown, (function (param) {
                                return false;
                              }));
                })
            }));
  } else {
    tmp$1 = React.createElement(React.Fragment, undefined);
  }
  return React.createElement("div", {
              className: nav
            }, React.createElement("div", {
                  className: navInside
                }, React.createElement("div", {
                      className: titleGroup
                    }, showingMenuDropDown ? React.createElement("i", {
                            className: CssJs.merge([
                                  "fas",
                                  "fa-times",
                                  navMenu
                                ]),
                            onClick: (function (param) {
                                return Curry._1(setShowingMenuDropDown, (function (param) {
                                              return false;
                                            }));
                              })
                          }) : React.createElement("i", {
                            className: CssJs.merge([
                                  "fas",
                                  "fa-bars",
                                  navMenu
                                ]),
                            onClick: (function (param) {
                                return Curry._1(setShowingMenuDropDown, (function (param) {
                                              return true;
                                            }));
                              })
                          }), tmp), match[0] ? React.createElement(EditModePrompt$PvpcontrollerWeb.make, EditModePrompt$PvpcontrollerWeb.makeProps(setEditMode, setShowingEditPrompt, "editModePrompt", undefined)) : React.createElement(React.Fragment, undefined)), tmp$1);
}

function Nav$Desktop(Props) {
  var session = Props.session;
  var editMode = Props.editMode;
  var setEditMode = Props.setEditMode;
  var match = React.useState(function () {
        return false;
      });
  var setShowingEditPrompt = match[1];
  var page = Belt_List.head(RescriptReactRouter.useUrl(undefined, undefined).path);
  var tmp;
  if (typeof session === "object" && session.NAME === "Verified") {
    switch (editMode) {
      case /* Unknown */0 :
          tmp = React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps({
                    height: "13px",
                    margin: "0",
                    marginTop: "5px",
                    marginLeft: "20px",
                    minWidth: "13px",
                    width: "13px"
                  }, undefined, undefined, undefined, undefined, undefined, undefined, undefined));
          break;
      case /* Enabled */1 :
          tmp = React.createElement(React.Fragment, undefined);
          break;
      case /* Disabled */2 :
          tmp = React.createElement("i", {
                key: "editModeEnable",
                className: editIcon + " fas fa-edit",
                onClick: (function (param) {
                    return Curry._1(setShowingEditPrompt, (function (_previousState) {
                                  return true;
                                }));
                  })
              });
          break;
      
    }
  } else {
    tmp = React.createElement(React.Fragment, undefined);
  }
  var tmp$1;
  if (typeof session === "object") {
    tmp$1 = React.createElement(React.Fragment, undefined);
  } else {
    var currentUrl = window.location.href;
    tmp$1 = React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("https://login.dark-gaming.com/?redirect=" + currentUrl, navItem(Caml_obj.caml_equal(page, "login")), React.createElement("span", {
                  className: navItemInner
                }, "Login"), false, undefined, "login", undefined));
  }
  return React.createElement("div", {
              className: nav
            }, React.createElement("div", {
                  className: navInside
                }, React.createElement("div", {
                      className: titleGroup
                    }, React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps("/", undefined, React.createElement("h1", {
                                  key: "h1",
                                  className: title
                                }, "PvP Manager"), undefined, undefined, undefined, undefined)), tmp), React.createElement("div", {
                      className: navList
                    }, navLinks.map(function (param) {
                          var key = param.key;
                          var isCurrentLandingPage = Belt_Option.mapWithDefault(page, "", (function (page) {
                                  return page;
                                })).length === 0 && param.isLandingPage;
                          var isCurrentPage = Caml_obj.caml_equal(page, key);
                          return React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps(param.href, navItem(isCurrentPage || isCurrentLandingPage), React.createElement("span", {
                                              className: navItemInner
                                            }, param.name), undefined, undefined, key, undefined));
                        }), tmp$1), match[0] ? React.createElement(EditModePrompt$PvpcontrollerWeb.make, EditModePrompt$PvpcontrollerWeb.makeProps(setEditMode, setShowingEditPrompt, "editModePrompt", undefined)) : React.createElement(React.Fragment, undefined)));
}

function Nav(Props) {
  var session = Props.session;
  var editMode = Props.editMode;
  var setEditMode = Props.setEditMode;
  if (MobileDetect$PvpcontrollerWeb.isMobile(undefined)) {
    return React.createElement(Nav$Mobile, {
                session: session,
                editMode: editMode,
                setEditMode: setEditMode
              });
  } else {
    return React.createElement(Nav$Desktop, {
                session: session,
                editMode: editMode,
                setEditMode: setEditMode
              });
  }
}

function makeProps(prim0, prim1, prim2, prim3, prim4) {
  var tmp = {
    session: prim0,
    editMode: prim1,
    setEditMode: prim2
  };
  if (prim3 !== undefined) {
    tmp.key = prim3;
  }
  return tmp;
}

var make = Nav;

exports.makeProps = makeProps;
exports.make = make;
/* nav Not a pure module */
